import React from 'react'
import { ActionButton, ActionsContainer } from './styles'

interface ProxyActionsProps {
	onSelectProxy?: () => void
	onManageProxies?: () => void
	onSaveCurrentProxy?: () => void
	currentProxy?: string
}

const ProxyActions: React.FC<ProxyActionsProps> = ({
	onSelectProxy,
	onManageProxies,
	onSaveCurrentProxy,
	currentProxy,
}) => {
	const handleSelectClick = () => {
		console.log('Select proxy clicked')
		onSelectProxy?.()
	}

	const handleManageClick = () => {
		console.log('Manage proxies clicked')
		onManageProxies?.()
	}

	const handleSaveClick = () => {
		console.log('Save current proxy clicked:', currentProxy)
		onSaveCurrentProxy?.()
	}

	return (
		<ActionsContainer>
			<ActionButton type="button" onClick={handleSelectClick} title='Select saved proxy'>
				📋
			</ActionButton>
			<ActionButton type="button" onClick={handleManageClick} title='Manage proxies'>
				⚙️
			</ActionButton>
			{currentProxy && (
				<ActionButton type="button" onClick={handleSaveClick} title='Save current proxy'>
					💾
				</ActionButton>
			)}
		</ActionsContainer>
	)
}

export default ProxyActions